<template>
    <EChart
        card
        class="mt-3"
        :options="chartOptions"
        :header="$t('sales')"
        :error="requestChart.getError()"
        :loading="requestChart.getLoading()"
        type="time"
    />
</template>



<script>
    import EChart from '@/components/common/EChart.vue';
    import { chartDataGroupBy, generateEChartData } from '@/utils/chart';

    export default {
        name: 'SalesChart',
        components: {
            EChart,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestChart: this.parentComponent.requestSalesChart,
            };
        },
        computed: {
            item() {
                return this.parentComponent.item;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                return {
                    urlParams: {
                        id: this.item.id,
                    },
                    requestParams: {
                        startDate: this.timeRange?.startDate,
                        endDate: this.timeRange?.endDate,
                        groupBy: this.groupBy,
                    },
                };
            },
            groupBy() {
                return chartDataGroupBy(this.timeRange);
            },
            chartData() {
                return this.requestChart.getData() || [];
            },
            chartOptions() {
                const chartData = this.chartData.reduce(
                    (acc, item) => {
                        acc.amount.push([item.date, item.amount]);
                        acc.quantity.push([item.date, item.quantity]);
                        return acc;
                    },
                    { amount: [], quantity: [] }
                );
                return {
                    yAxis: [
                        {
                            type: 'value',
                            name: this.$t('quantityPieces'),
                            position: 'right',
                        },
                        {
                            type: 'value',
                            name: this.$t('salesAmount'),
                        },
                    ],
                    series: [
                        {
                            name: this.$t('quantityPieces'),
                            type: 'line',
                            data: generateEChartData(this.timeRange, chartData.quantity),
                        },
                        {
                            name: this.$t('salesAmount'),
                            type: 'bar',
                            yAxisIndex: 1,
                            data: generateEChartData(this.timeRange, chartData.amount),
                            tooltip: {
                                valueFormatter: value => this.$format.currency(value),
                            },
                        },
                    ],
                };
            },
        },
        watch: {
            item: {
                immediate: true,
                handler: 'loadData',
            },
            timeRange: {
                immediate: false,
                handler: 'loadData',
            },
        },
        methods: {
            loadData() {
                this.requestChart.reset();
                this.fetchChart();
            },
            fetchChart(params = {}) {
                this.requestChart.get(this.apiParams);
            },
        },
    };
</script>
